
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {fetchReports} from 'redux/modules/reports/actions'
import {getReports} from 'redux/modules/reports/selectors'
import {Table, Column, Cell} from 'components/Table'
import {Link} from 'react-router'
import {push as pushState} from 'react-router-redux'
import Icon from 'components/Icon'
import {reportDeleteConfirm} from 'redux/modules/ui/modal/actions'
import DayTime from 'components/DayTime'
import UpgradePanel from 'components/UpgradePanel'

export class ReportsView extends React.Component {
  static propTypes = {
    reports: PropTypes.array,
    fetchReports: PropTypes.func,
    reportDeleteConfirm: PropTypes.func,
    pushState: PropTypes.func
  }

  static contextTypes = {
    permissions: PropTypes.object,
    crossSiteMode: PropTypes.bool
  }

  componentDidMount() {
    const {fetchReports} = this.props
    const {crossSiteMode} = this.context

    fetchReports(crossSiteMode)
  }

  render() {
    const {reports, reportDeleteConfirm, pushState} = this.props
    const {permissions, crossSiteMode} = this.context
    const isAllowed = permissions.read.includes('@features/reports')
    const prefix = crossSiteMode ? '/cross-site' : ''

    if (!isAllowed) {
      return (
        <UpgradePanel fullWidth>
          <p>
            Do you want the ability to save and export all this valuable data?
            Want to impress your CEO, colleagues or investors by sending them weekly updates?
            Upgrade now and start doing that today!
          </p>
        </UpgradePanel>
      )
    }

    return (
      <div className='reports-view'>
        <Table
          data={reports}
          empty={
            <div>
              There are no reports just yet. You can create one in <Link to={`${prefix}/analytics`}>Explorer</Link>.
            </div>
          }
          loading={!reports}
          className='reports-view_list'
          onRowClick={report => pushState(`${prefix}/analytics/reports/${report.id}`)}
          rowClassName='table-row reports-view_list-row'
          hover
        >
          <Column
            header='Report Name'
            cell={report => <Cell>{report.name}</Cell>}
          />
          <Column
            width='130px'
            header='Created at'
            cell={report => <Cell><DayTime date={report.createdAt} /></Cell>}
          />
          <Column
            width='20px'
            cell={report => (
              <Cell className='reports-view_view'>
                <Link to={`${prefix}/analytics/reports/${report.id}`}>
                  <Icon className='reports-view_view-icon' name='eye' tooltip='View report' />
                </Link>
              </Cell>
            )}
          />
          <Column
            width='20px'
            cell={report => (
              <Cell className='reports-view_delete'>
                <Icon
                  className='reports-view_delete-icon'
                  name='trash'
                  onClick={evt => {
                    evt.stopPropagation()
                    reportDeleteConfirm(report)
                  }}
                  tooltip='Delete report'
                />
              </Cell>
            )}
          />
        </Table>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    reports: getReports(state)
  }
}

const mapDispatchToProps = {
  fetchReports,
  reportDeleteConfirm,
  pushState
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsView)



// WEBPACK FOOTER //
// ./client/views/ReportsView/index.js